<template>
  <div>
    <!-- <div class="input-wrap">
    	<label >标题</label>
    	<el-input type="text" v-model="info.title" placeholder="请输入标题" class="sort_input"></el-input>
    </div> -->
    <div class="input-wrap">
      <label>跳转地址</label>
      <el-input
        v-model="info.url"
        placeholder="请输入跳转地址"
        class="input"
      ></el-input>
    </div>
    <div class="img-wrap">
      <label>图片(尺寸: 252*252)</label>
      <imageUpload v-model="carousel_img" :limit="1" />
    </div>
    <div class="btn-wrap">
      <el-button type="primary" class="confirmBtn" @click="confirmClick"
        >保存</el-button
      >
      <el-button @click="cancelClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import imageUpload from "@/components/ImageUpload";
import { getServiceDetail, editService } from "@/api/service-manage";

export default {
  name: "messagepush",
  data() {
    return {
      info: {
        sort: "",
        carousel_img: "",
        url: "",
        title: "",
        carousel_url: "",
      },
      carousel_img: [],
      type: "add",
    };
  },
  components: {
    imageUpload,
  },
  mounted() {
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this._getServiceDetail(uuid);
    }
    // this.init();
  },
  methods: {
    async confirmClick() {
      this.info.img = this.carousel_img.join("");
      const { title, img, url } = this.info;
      if (!title) {
        this.$message("标题不能为空");
        return;
      }
      if (!url) {
        this.$message("请输入跳转地址");
        return;
      }
      if (!img) {
        this.$message("请上传图片");
        return;
      }
      const { status } = await editService(this.info);
      if (status === 200) this.$router.go(-1);
    },
    cancelClick() {
      this.$router.go(-1);
    },
    async _getServiceDetail(id) {
      const { status, data } = await getServiceDetail(id);
      if (status !== 200) return;
      this.info = data;
      this.carousel_img = [data.img];
    },
  },
};
</script>

<style lang="less" scoped>
.input-wrap {
  margin-top: 30px;
  .sort_input {
    width: 300px;
  }
}
label {
  display: block;
  margin-bottom: 10px;
}
.img-wrap {
  margin-top: 30px;
}
.btn-wrap {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  .confirmBtn {
    margin-right: 50px;
  }
}
.input-wrap {
  width: 400px;
}
</style>
